
import { SOCIAL_PLATFORMS_METADATA } from '@/constants';
import { ProjectViewMixin } from '@/mixins/ProjectViewMixin';
import { AppleBusinessConnectPlatformData, Bot, SupportedPlatform } from 'ignite360-core';
import _merge from 'lodash.merge';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import AppleBusinessConnectSettingsCard from '@/components/apple/AppleBusinessConnectSettingsCard.vue';
import AppleBusinessConnectLoginCard from '@/components/apple/AppleBusinessConnectLoginCard.vue';

@Component({
  name: 'project-social-platform-apple-business-connect',
  components: {
    AppleBusinessConnectLoginCard,
    AppleBusinessConnectSettingsCard,
  },
})
export default class ProjectSocialPlatformAppleBusinessConnect extends mixins(ProjectViewMixin) {
  get isPlatformConnected(): boolean {
    const meta = SOCIAL_PLATFORMS_METADATA.find(
      (m) => m.value === SupportedPlatform.AppleBusinessConnect,
    );
    return !!this.bot && !!meta?.isConnected?.(this.bot);
  }

  onConnect(data: Partial<AppleBusinessConnectPlatformData>) {
    const newBot: Bot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.AppleBusinessConnect]: data,
      },
    });
    this.$store.commit('bots/updateBot', newBot);
  }

  onDisconnect() {
    const newBot: Bot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.AppleBusinessConnect]: {
          companyId: '',
          locationId: '',
          locationName: '',
          brandId: '',
          brandName: '',
        },
      },
    });
    this.$store.commit('bots/updateBot', newBot);
  }

  get companyId(): string {
    return this.bot?.platformData.appleBusinessConnect?.companyId || '';
  }

  get brandId(): string {
    return this.bot?.platformData.appleBusinessConnect?.brandId || '';
  }

  get locationId(): string {
    return this.bot?.platformData.appleBusinessConnect?.locationId || '';
  }
}
